import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from 'ag-grid-community';

type CellRendererParams = ICellRendererParams<any, string> & {
  getLinkFn?: (param: any) => string[];
}

@Component({
  selector: 'app-ag-text-with-link',
  standalone: true,
  imports: [RouterLink],
  templateUrl: 'ag-text-with-link.component.html',
  styleUrl: 'ag-text-with-link.component.scss'
})
export class AgTextWithLinkComponent implements ICellRendererAngularComp {
  text = '';
  link: string[] | null = null;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.text = params.value ?? '';
    this.link = params.getLinkFn ? params.getLinkFn(params) : null;

    return true;
  }
}
